import React, { useContext, useState } from 'react'
import StateContext from '../../../../StateContext'
import { MDBModal, MDBModalBody, MDBModalHeader } from 'mdbreact';
import EditUtenlandsProff from './EditUtenlandsProff';
import { Link } from 'react-router-dom';

function UtenlandsProfferListTemplate({player}) {

    const {loggedIn} = useContext(StateContext)
    const AVATAR_URL = "https://firebasestorage.googleapis.com/v0/b/backend-footgrail.appspot.com/o/players%2Favatar-default.jpg?alt=media&token=06ae4bfc-6276-40aa-ad58-0968fea10f8e"
    
    const [showModal, setShowModal] = useState(false);

    function toggleModal() {
        if (showModal) {
            setShowModal(false)
        } else {
            setShowModal(true)
        }
    }

    return (
        <div className="col-4 col-md-3 my-3">
            <div className="card">
                <img src={player.player_image || AVATAR_URL} alt="" className="player-image" />
                <div className="card-body">
                    <h6><Link to={`/players-api/${player.player_id}`}>{player.player_name}</Link></h6>
                    <small>{player.team_name || player?.api_data?.team_name}</small>
                    {loggedIn && (
                        <div>
                            <button className="btn btn-sm btn-light" onClick={() => setShowModal(true)}>Rediger</button>
                        </div>
                    )}
                </div>
            </div>

            <MDBModal size="fluid" isOpen={showModal} toggle={toggleModal}>
                <MDBModalHeader toggle={toggleModal}>Rediger</MDBModalHeader>
                <MDBModalBody>

                    <EditUtenlandsProff player={player} />

                </MDBModalBody>
            </MDBModal>


        </div>
    )
}
export default UtenlandsProfferListTemplate